module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0043.jpg?v=a900278d";